
export default {
	data: state => state.data,
	department: state => state.department,
	meta: state => state.meta,
	plans: state => state.plans,
	currencies: state => state.currencies,
	loading: state => state.loading,
	partnerships: state => state.partnerships,
	countries: state => state.countries,
	vacation: state => state.vacation,
	lastVacation: state => state.lastVacation
}
